export default __webpack_public_path__ + "static/media/Marathi_bm_1.72b4c036.mp3";